import React from "react";
import { MddDialog, MddDialogButtons } from "../../../common";

interface IMddStudySiteApplyIdConfirmDialogProps {
  open: boolean;
  onConfirm: () => void;
  onClose: () => void;
}

export const MddStudySiteApplyIdConfirmDialog = ({
  open,
  onConfirm,
  onClose
}: IMddStudySiteApplyIdConfirmDialogProps): JSX.Element => {
  return (
    <MddDialog
      dialogProps={{
        open,
        maxWidth: "sm",
        fullWidth: true
      }}
      dialogTitleProps={{
        title: "Apply Sponsor Site ID to Protocols"
      }}
      dialogContentProps={{
        className: "mdd-dialog--content-100percent"
      }}
      dialogContent={
        <div className="mdd-study-site--dialog-content">
          <p className="mdd-study-site--dialog-text">
            Turning this option on will override any Sponsor Site ID per
            participating protocol you have entered for individual protocols.
            Are you sure you want to do this?
          </p>
        </div>
      }
      dialogActions={
        <MddDialogButtons
          saveButtonText="Apply"
          saveButtonProps={{
            onClick: onConfirm
          }}
          closeButtonProps={{
            onClick: onClose
          }}
        />
      }
      showCloseButton
      onCloseClick={onClose}
    />
  );
};
